<template>
  <div class="columns">
    <div class="column"></div>
    <div class="column">
      <article class="message is-danger">
        <div class="message-header has-text-centered">
          <p class="has-text-centered">Error</p>
          <button
            class="delete"
            aria-label="delete"
            @click="brokenArrow"
          ></button>
        </div>
        <div class="message-body">
          <p class="has-text-centered mb-6">
            <i class="fas fa-exclamation-circle fa-10x"></i>
          </p>
          We encountered an error while processing your request.
        </div>
      </article>
    </div>
    <div class="column"></div>
  </div>
</template>

<script>
export default {
  name: "ZESABuyError",
  emits: ["brokenarrow"], //everything went to shit go back to calculator
  methods: {
    brokenArrow() {
      this.$emit("brokenarrow");
    },
  },
};
</script>

<style></style>
